<template>
  <b-img
    v-if="qr.length"
    :src="qr"
    class="qr-image"
  />
</template>

<script>

import { BImg } from 'bootstrap-vue'

export default {
  name: 'QRCodeImage',
  components: { BImg },
  props: {
    qr: { type: String, required: true },
  },
}
</script>

<style scoped>
.qr-image {
  border: 4px solid #333;
  padding: 10px;
  background-color: #fff;
  border-radius: 8px;
  display: inline-block;
  max-width: 300px;
}
</style>
